<!--Select Type-->
<div class="cm-Menu">
	<div class="CenterDiv">
		<h4>NOTE: This only changes data for the selected month</h4>
	</div>
</div>

<div class="cm-Menu">
	<h4>Select Type:</h4>

	<div class="SubMenuRadio">
		<input [disabled]="IsLoading() == true" name="SelectionID" [(ngModel)]="SelectionID" value="1" id="All" class="RAD FlexRight" type="radio" />
		<label for="All">All Days</label>

		<input
			[disabled]="IsLoading() == true"
			name="SelectionID"
			[(ngModel)]="SelectionID"
			value="2"
			id="Weekdays"
			class="RAD FlexRight LargeLeft"
			type="radio"
		/>
		<label for="Weekdays">Weekdays</label>

		<input
			[disabled]="IsLoading() == true"
			name="SelectionID"
			[(ngModel)]="SelectionID"
			value="3"
			id="Weekends"
			class="RAD FlexRight LargeLeft"
			type="radio"
		/>
		<label for="Weekends">Weekends</label>

		<input
			[disabled]="IsLoading() == true"
			name="SelectionID"
			[(ngModel)]="SelectionID"
			value="4"
			id="SelectDay"
			class="RAD FlexRight LargeLeft"
			type="radio"
		/>
		<label for="SelectDay">Selected Day</label>

		<input
			[disabled]="IsLoading() == true"
			name="SelectionID"
			[(ngModel)]="SelectionID"
			value="5"
			id="EveryX"
			class="RAD FlexRight LargeLeft"
			type="radio"
		/>
		<label for="EveryX">Every x Days</label>
	</div>

	<div class="DOWMenu" *ngIf="SelectionID == 4">
		<label>Day of the week:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="DOW" [(ngModel)]="DOW">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstDOW" [ngValue]="o">{{ o }}</option>
		</select>
	</div>

	<div class="EveryXMenu" *ngIf="SelectionID == 5">
		<div class="ThreeItem">
			<label class="FlexItem">Every</label>
			<input [disabled]="IsLoading() == true" class="form-control FlexItem FitWidth" type="number" min="1" max="31" [(ngModel)]="EveryXDays" />
			<label class="FlexItem">Days</label>
		</div>

		<div class="ThreeItem">
			<label class="FlexItem">Starting on day</label>
			<input [disabled]="IsLoading() == true" class="form-control FlexItem FitWidth" type="number" min="1" max="31" [(ngModel)]="StartDay" />
			<label class="FlexItem">of the current month</label>
		</div>

		<div class="ThreeItem">
			<label class="FlexItem">Skip Weekends?</label>
			<input [disabled]="IsLoading() == true" class="form-control FlexItem CheckWidth" type="checkbox" [(ngModel)]="SkipWeekends" />
		</div>
	</div>
</div>

<!--Options-->
<div class="cm-Menu">
	<h4>Options:</h4>

	<!--Options grid 2 col-->
	<div class="SubMenu2Col">
		<label>School Day: </label>
		<select [disabled]="IsLoading() == true" class="form-control" name="SchoolDay" [(ngModel)]="SchoolDayID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstSchoolDay" [ngValue]="o.DayID">
				{{ o.DayDesc }}
			</option>
		</select>

		<label>Bell Schedule: </label>
		<select [disabled]="IsLoading() == true" class="form-control" name="BellSchedule" [(ngModel)]="BellScheduleID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstBellSchedule" [ngValue]="o.BellScheduleID">
				{{ o.BellScheduleDesc }}
			</option>
		</select>

		<label>Open: </label>
		<select [disabled]="IsLoading() == true" class="form-control" name="IsOpen" [(ngModel)]="IsOpen">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstIsOpen" [ngValue]="o">{{ o }}</option>
		</select>
	</div>
</div>

<!--Date Range Options-->
<!-- <div class="cm-Menu">
	<h4>Select Date Range:</h4>

	<div class="SubMenuRadio">
		<input [disabled]="IsLoading() == true" type="radio" name="DateModeID" [(ngModel)]="DateModeID" [value]="0" class="RAD FlexRight" />
		<label>Months</label>

		<input [disabled]="IsLoading() == true" type="radio" name="DateModeID" [(ngModel)]="DateModeID" [value]="1" class="RAD FlexRight LargeLeft" />
		<label>Semesters/School Year</label>
	</div>

	<div *ngIf="DateModeID == 0" class="TopMargin DateModeMonthGrid">
		<label>Start Month:</label>
		<select
			[disabled]="IsLoading() == true"
			class="form-control"
			name="StartMonthYear"
			[(ngModel)]="StartMonthYear"
			[style.color]="StartMonthYear == null || StartMonthYear.NextColor == null ? 'Black' : StartMonthYear.NextColor"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstMonthYear" [ngValue]="o" [style.color]="o.NextColor">{{ o.Desc }}</option>
		</select>

		<label>End Month:</label>
		<select
			[disabled]="IsLoading() == true"
			class="form-control"
			name="EndMonthYear"
			[(ngModel)]="EndMonthYear"
			[style.color]="EndMonthYear == null || EndMonthYear.NextColor == null ? 'Black' : EndMonthYear.NextColor"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstMonthYear" [ngValue]="o" [style.color]="o.NextColor">{{ o.Desc }}</option>
		</select>
	</div>

	<div *ngIf="DateModeID == 1" class="TopMargin SemesterSelectDiv">
		<label>Semesters:</label>
		<p-listbox
			[options]="lstSemester"
			[(ngModel)]="SchoolYearSemesters"
			optionLabel="Semester"
			[metaKeySelection]="false"
			[checkbox]="true"
			[filter]="true"
			[multiple]="true"
			[listStyle]="{ 'max-height': '250px' }"
		>
			<ng-template let-SemesterItem pTemplate="item">
				<div class="SemesterItemDiv">
					<label>{{ SemesterItem.Semester }}</label>
					<p>({{ SemesterItem.StartDateDesc }} - {{ SemesterItem.EndDateDesc }})</p>
				</div>
			</ng-template>
		</p-listbox>
	</div>
</div> -->

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>
